//TODO FEEL FREE TO ADJUST THIS TRANSPILER FOR YOUR SPECIFIC SECTION SYNC WITH JON IF YOU HAVE QUESTIONS
// imports
import { getCookie } from '@insticator/insticator-ui'; // iui-utils

export const transpileConfigurationData = (data = {}) =>({
    fetchingConfigs: false,
    fetchingConfigsFailed: false,
    commentingUnitUUID: data.commentingUnitUUID,
    commentingUnitConfigurationUUID: data.commentingUnitConfigurationUUID,
    isActive: data.isActive,
    stored_general: transpileGeneralData(data.general),
    general: transpileGeneralData(data.general),
    stored_moderation: transpileModerationData(data.moderation),
    moderation: transpileModerationData(data.moderation),
    stored_commentsTree: transpileCommentsTreeData(data.commentsTree),
    commentsTree: transpileCommentsTreeData(data.commentsTree),
    stored_colorSchema: transpileColorSchemaData(data.colorSchema),
    colorSchema: transpileColorSchemaData(data.colorSchema),
    stored_avatarPack: transpileAvatarPackData(data.avatarPack),
    avatarPack: transpileAvatarPackData(data.avatarPack),
    stored_community: transpileCommunityData(data.community),
    community: transpileCommunityData(data.community)
});

// ^-^ ^-^ ^-^ ^-^ ^-^   GENERAL TRANSPILER + HELPERS   ^-^ ^-^ ^-^ ^-^ ^-^ //

export const transpileGeneralData = (data = {}) => ({
    savingGeneral: false,
    updated: false,
    uploadingLogo: false,
    isPageIDEnabled: !!data.isPageIDEnabled,
    name: {
        value: data.name ? data.name: 'hello',
        valid: data.name ? data.name: null
    },
    isPromoteCommentsEnabled: !!data.isPromoteCommentsEnabled,
    isTurnOffRepliesEnabled: !!data.isTurnOffRepliesEnabled,
    isActiveUsersIndicatorEnabled: !!data.isActiveUsersIndicatorEnabled,
    activeUsersIndicatorTitle: {
        value: data.activeUsersIndicatorTitle ? data.activeUsersIndicatorTitle : '',
        valid: true
    },
    fontSize: data.fontSize ? data.fontSize : 15, // 15-Regular, 16-Comfortable, 17-Accessible
    weight: data.weight ? data.weight : 400, // 400-Regular, 500-Medium
    // NULL will be returned for non-admin user
    advancedSettings: !!data.advancedSettings ? transpileGeneralAdvanceSettings(data.advancedSettings) : transpileGeneralAdvanceSettings()
});

const transpileGeneralAdvanceSettings = (data = {}) => ({
    group: !!data.group ? data.group : 'INTERNAL',
    isLoadCommentsButtonEnabled: !!data.isLoadCommentsButtonEnabled,
    allowDisqusAccountLink: !!data.allowDisqusAccountLink,
});

// ^-^ ^-^ ^-^ ^-^ ^-^   MODERATION TRANSPILER + HELPERS   ^-^ ^-^ ^-^ ^-^ ^-^ //

export const transpileModerationData = (data = {}) => ({
    savingModeration: false,
    updated: false,
    uuid: data.uuid,
    moderationType: !!data.moderationType ? data.moderationType : "POST_MODERATION",
    anonymousCommenting: data.commentingUserType !== 'ONLY_AUTHORIZED_USER',
    onlyAnonymousCommenting: data.commentingUserType === 'ONLY_ANONYMOUSE_USER',
    isMediaContentEnabled: !!data.isMediaContentEnabled,
    isVideosEnabled: !!data.isVideosEnabled,
    isImagesEnabled: !!data.isImagesEnabled,
    isGifsEnabled: !!data.isImagesEnabled,
    autoBlockAuthors: !!data.autoBlockAuthors,
    autoRemoveComments: !!data.autoRemoveComments,
    blockCommentsWithLink: !!data.blockCommentsWithLink,
    isEmojiReactionsEnabled: !!data.isEmojiReactionsEnabled,
    // NULL will be returned for non-admin user
    advancedSettings: data.advancedSettings ? transpileModerationAdvanceSettings(data.advancedSettings) : transpileModerationAdvanceSettings()
});

const transpileModerationAdvanceSettings = (data = {}) => ({
    isAIModerationEnabled: !!data.isAIModerationEnabled,
    minApprovalScore: !!data.minApprovalScore ? data.minApprovalScore : 0,
    maxApprovalScore: !!data.maxApprovalScore ? data.maxApprovalScore : 0
});

// ^-^ ^-^ ^-^ ^-^ ^-^   COMMENTS TREE TRANSPILER + HELPERS   ^-^ ^-^ ^-^ ^-^ ^-^ //

const transpileCommentsTreeData = (data = {}) => ({
    uuid: data.uuid,
    treeType: !!data.treeType ? data.treeType : "BASIC",
    commentsInitialLoadLimit: !!data.commentsInitialLoadLimit || data.commentsInitialLoadLimit === 0 ? data.commentsInitialLoadLimit : 5,
    repliesInitialLoadLimit: !!data.repliesInitialLoadLimit || data.repliesInitialLoadLimit === 0 ? data.repliesInitialLoadLimit : 1,
    commentsLoadMoreLimit: !!data.commentsLoadMoreLimit || data.commentsLoadMoreLimit === 0 ? data.commentsLoadMoreLimit : 10,
    repliesLoadMoreLimit: !!data.repliesLoadMoreLimit || data.repliesLoadMoreLimit  === 0 ? data.repliesLoadMoreLimit : 5
});

// ^-^ ^-^ ^-^ ^-^ ^-^   COLOR SCHEMA + HELPERS   ^-^ ^-^ ^-^ ^-^ ^-^ //

export const transpileColorSchemaData = (data = {}) => ({
    uuid: data.uuid,
    background: {
        value: !!data.background ? '#' + data.background : "#FFFFFF",
        valid: !!data.background ? true : null
    },
    primaryText: {
        value: !!data.primaryText ? '#' + data.primaryText : "#062B75",
        valid: !!data.primaryText ? true : null
    },
    secondaryText: {
        value: !!data.secondaryText ? '#' + data.secondaryText : "#ABB2C3",
        valid: !!data.secondaryText ? true : null
    },
    branding: {
        value: !!data.branding ? '#' + data.branding : "#1494F4",
        valid: !!data.branding ? true : null
    },
    primaryButtonLabel: {
        value: !!data.primaryButtonLabel ? '#' + data.primaryButtonLabel : "#FFFFFF",
        valid: !!data.primaryButtonLabel ? true : null
    },
    errorValidation: {
        value: !!data.errorValidation ? '#' + data.errorValidation : "#DF1D1D",
        valid: !!data.errorValidation ? true : null
    }
});

// ^-^ ^-^ ^-^ ^-^ ^-^   AVATAR PACK TRANSPILER + HELPERS   ^-^ ^-^ ^-^ ^-^ ^-^ //

const transpileAvatarPackData = (data) => !!data ? data : "DEFAULT";

// ^-^ ^-^ ^-^ ^-^ ^-^   COMMUNITY TRANSPILER + HELPERS   ^-^ ^-^ ^-^ ^-^ ^-^ //

const transpileCommunityData = (data = {}) => ({
    uuid: data.uuid,
    updated: false,
    isCommunityEnabled: !!data.isCommunityEnabled,
    title: {
        value: !!data.title ? data.title : "",
        valid: true
    },
    position: !!data.position ? data.position : "IN_UNIT",
    showTopArticles: !!data.showTopArticles,
    topArticlesInitialLoadLimit: !!data.topArticlesInitialLoadLimit ? data.topArticlesInitialLoadLimit : 10,
    topArticlesDaysTimeFrame: {
        value: !!data.topArticlesDaysTimeFrame ? data.topArticlesDaysTimeFrame : 0,
        valid: !!(data.topArticlesDaysTimeFrame || data.topArticlesDaysTimeFrame === 0) ? true : null
    },
    placeholderImageType: !!data.placeholderImageUrl ? data.placeholderImageUrl === '' ? 'standard' : 'custom' : 'standard',
    placeholderImageUrl: !!data.placeholderImageUrl ? data.placeholderImageUrl : '',
    placeholderImageName: !!data.placeholderImageUrl ? (data.placeholderImageUrl === '' ? null : data.placeholderImageUrl.split('/').pop()) : null,
    showTopCommenters: !!data.showTopCommenters,
    topCommentersInitialLoadLimit: !!data.topCommentersInitialLoadLimit ? data.topCommentersInitialLoadLimit : 10
});

// ^-^ ^-^ ^-^ ^-^ ^-^   CODE TRANSPILER + HELPERS   ^-^ ^-^ ^-^ ^-^ ^-^ //
export const transpileCommentingUnitCodeData = (data = {}) => ({
    headerCode: !data.headerCode ? '' : data.headerCode,
    bodyCode: !data.bodyCode ? '' : data.bodyCode
});
